import { type ReactNode } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

type Props = {
  open: boolean;
  onClose: () => void;
  narrow: boolean;
  children: ReactNode;
};

export const ApplyModal = ({ open, onClose, narrow, children }: Props) => (
  <>
    {open && <div className="fixed inset-0 z-40 bg-gray-900/30" aria-hidden="true" />}
    <Dialog
      open={open}
      modal={false}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <DialogContent
        className={cn(
          "w-[90vw] max-h-[90vh] flex flex-col overflow-hidden p-0 gap-0",
          narrow ? "sm:max-w-[600px]" : "sm:max-w-[900px]",
        )}
        hideClose={false}
        closeButtonClassName="z-10 rounded-full bg-white! opacity-100 shadow-md [&>svg]:size-8"
      >
        <div className="min-h-0 overflow-y-auto pt-8 pr-16 pb-8 pl-8">{children}</div>
      </DialogContent>
    </Dialog>
  </>
);

export default ApplyModal;
